import { createSelector } from 'reselect';

const getDone = _ => _.done;
const getMarkers = _ => _.markers;
const getCollectibles = (_, collectibles) => collectibles;

export const getOverallScore = createSelector(
  getMarkers,
  getDone,
  getCollectibles,
  (markers, dones, collectibles) => {
    const filtered = markers.filter(obj => collectibles.includes(obj.category));
    const total = filtered.length;
    const selected = filtered.filter(obj => dones.includes(obj.id));
    const count = selected.length;
    const percent = total === 0 ? 0 : Math.floor((count * 100) / total);
    const completed = percent === 100;
    return { completed, count, percent, total };
  }
);

export default getOverallScore;
